import React from "react";
import "./styles.scss";
import ProductCard from "Components/Productcard";
import ProductSlider from "Components/ProductSlider";
import { useWindowSize } from "Utilities";

const MatchingProducts = ({ matchingProducts }) => {
  const [width] = useWindowSize();

  const hasAnyReview = matchingProducts?.length && matchingProducts?.some((product) => product?.review_status == "1");

  return (
    <>
      {width > 1280 && matchingProducts?.length ? (
        <div className="matched__related__product pt-xl-12 pb-8 w-1/1">
          <h2>Bijpassende producten</h2>
          <div className="flex wrap gap-x-4 gap-y-4 gap-4-14 xl-gap-x-8 xl-gap-y-16 pb-3">
            {matchingProducts?.map((item, index) => (
              <React.Fragment key={`relatedproductGrid${index}`}>
                <ProductCard data={item} key={`product__related_${index}`} related={true} hasAnyReview={hasAnyReview} />
              </React.Fragment>
            ))}
          </div>
        </div>
      ) : (
        ""
      )}

      {width < 1280 && matchingProducts?.length ? (
        <div className="matched__related__product">
          <ProductSlider title="Bijpassende producten" data={matchingProducts} pageName="pdp" />
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default MatchingProducts;
